/*
* @Author: Dorfmann K.
* @Date:   2020-05-27 17:04:56
* @Last Modified by:   MiheevAV
* @Last Modified time: 2020-05-28 10:16:27
*/

class requestsScripts {


  /**
   * Изменяет контент первого блока запросов
   * @param  {int} value 1 - по филиалам, 2 - по авиаметеорологической сети
   * @return {void} Простой переключатель
   */
  typesListChange(value){
      $('#menu-1-1').find('li').hide();
      $('.requests-' + value).show();
  }

  //--------------------------------------------------------------------------------------- Формирование списка ародромов
  filialListChange(filialID, filialListVal) {

    if (filialID > 0) {
      $.ajax({
        type: "POST",
        url: "module/requests/ajaxHandler.php",
        data: {
          filialID: filialID,
        },
        dataType: "JSON"
      }).done(function(response) {
        $('.requestsAirdromeList').html("<option value='0'>Выбрать все</option>");
        var airdromeOptionList = "";
        $.each(response, function(index, val) { //--- val[0](fcode_en) val[1](fname)
          airdromeOptionList += "<option value='" + val[0] + "'>" + val[1] + "</option>";
        });
        $('.requestsAirdromeList').append(airdromeOptionList);

      });
    } else {
      $('.requestsAirdromeList').html("<option value='0'>Выбрать все</option>");
    }
  }
  //-------------------------------------------------------------------------------------- Изминения списка с аэродромами
  airdromeListChange(airdromeID) {

    this.airdromeListVal = airdromeID;

  }
  //------------------------------------------------------------------------------ Формирование списка марок оборудования
  equipmentsTypeListChange(equipmentType) {

    if (equipmentType > 0) {
      $.ajax({
        type: "POST",
        url: "module/requests/ajaxHandler.php",
        data: {
          equipmentType: equipmentType,
        },
        dataType: "JSON",
      }).done(function(response) {

        $('.requestsEquipmentsMarksList').html("<option value='0'>Выбрать все</option>");
        var airdromeOptionList = "";
        $.each(response, function(index, val) { //--- val[0](fcode_en) val[1](fname)
          airdromeOptionList += "<option value='" + val[0] + "'>" + val[1] + "</option>";
        });
        $('.requestsEquipmentsMarksList').append(airdromeOptionList);
        this.equipmentsTypeListVal = equipmentType;
      });

    } else {
      $('.requestsEquipmentsMarksList').html("<option value='0'>Выбрать все</option>");
    }

  }

  //------------------------------------------------------------------------------------------------ Формирование таблицы
  requestsTableResult() {

    $('.requestsOk').css("display", "none");
    $('.requestPreloader').css("display", "block");
    $.ajax({
      type: "POST",
      async: true,
      // timeout: 10000,
      url: ($('.requestsTypesList').val() == 1) ? "module/requests/requests.php" : "module/requests/requests2.php",
      data: {

        // requests.php
        requestsOk: true,
        requestsFilialsListID: $('.requestsFilialsList').val(),
        requestsAirdromeList: $('.requestsAirdromeList').val(),
        requestsAirdromeTotal: $('.requestsAirdromeTotal').val(),
        requestsEquipmentsTypeList: $('.requestsEquipmentsTypeList').val(),
        requestEquipmentsTypeTotal: $('.requestEquipmentsTypeTotal').val(),
        requestsEquipmentsMarksList: $('.requestsEquipmentsMarksList').val(),
        requestsEquipmentsVidList: $('.requestsEquipmentsVidList').val(),
        requestsFilialSummaryTable: $('#requestsFilialSummaryTable').is(":checked") ? 1 : 0,
        requestsAirportSummaryTable: $('#requestsAirportSummaryTable').is(":checked") ? 1 : 0,
        requestExpiredResource: $('#requestExpiredResource').is(":checked") ? 1 : 0,
        requestOnlyAmtk: $('#requestOnlyAmtk').is(":checked") ? 1 : 0,
        // requests2.php
        requestsRazrList: $('.requestsRazrList').val(),
        requestsStatusesList: $('.requestsStatusesList').val(),
        requestsKatgList: $('.requestsKatgList').val(),
        requestsOVDList: $('.requestsOVDList').val(),
        requestsEquipmentsYearIssueB: $('.requestsEquipmentsYearIssueB').val(),
        requestsEquipmentsYearIssueE: $('.requestsEquipmentsYearIssueE').val(),
        requestsEquipmentsYearIntroB: $('.requestsEquipmentsYearIntroB').val(),
        requestsEquipmentsYearIntroE: $('.requestsEquipmentsYearIntroE').val(),
        requestsEquipmentsYearEndB: $('.requestsEquipmentsYearEndB').val(),
        requestsEquipmentsYearEndE: $('.requestsEquipmentsYearEndE').val()
      },
      error: function(resposne) {
      },
    }).done(function(response) {

      $('.requestPreloader').css("display", "none");
      $('.requestsOk').css("display", "block");

      //--- Если нет объвёртки для результатирующей таблицы то создаём (костыль!)
      if(typeof $('#requestsTableWrap').attr('id') == 'undefined'){
         $('.requestsMenu').parent().append("<div id='requestsTableWrap'></div>");
      }

      $('#requestsTableWrap').html(response);

    });
  }

  printData() {

    var printTable = $('#toPrint').html(),
      obj = document.createElement("div");

    $(obj).append(printTable);
    $(obj).find('.trButtons').remove();

    $(obj).printThis();
    obj.remove();

  }
}

//---
window.requestScr = new requestsScripts();


